import settingsReducer from './slice';

export default settingsReducer;

export * from './data';
export * from './selectors';
export * from './slice';
export * from './types';
